import { render, staticRenderFns } from "./PriceListGroupForm.vue?vue&type=template&id=16052fd4"
import script from "./PriceListGroupForm.vue?vue&type=script&lang=js"
export * from "./PriceListGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports